module.exports = __webpack_public_path__ + "media/images/shield-alt-solid-ca57a6e527ebd540e99d9af7acdd60eb.svg";